export default __webpack_public_path__ + "static/media/performance.87910ee8.jpg";